export default "__VITE_ASSET__9bac17b3__"